var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    _vm._b(
      {
        ref: "popover",
        attrs: { placement: "top-start", trigger: "click" },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between mb-2" },
                    [
                      _c("div", [
                        _vm._v("Click to insert into the cursor position:"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn line-height-10 p-0 bg-gray-hover-200",
                            attrs: { type: "button" },
                            on: { click: _vm.close },
                          },
                          [_c("i", { staticClass: "fas fa-times fa-sm fa-fw" })]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("Picker", {
                    attrs: { data: _vm.emojiIndex, showPreview: false },
                    on: { select: _vm.onSelect },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "reference",
              fn: function () {
                return [
                  _vm._t("default", function () {
                    return [_vm._v("\n      Emoji\n    ")]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "el-popover",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }